require([
],
function () {
    
    var layeredImagesUrls;
    var layeredImagesToBePreloaded;
    var layeredImagesPreLoaded;
    const COMPOSITE_IMAGE_THUMBNAIL_SELECTOR = ".composite-image-thumb";
    const CONFIGURATOR_DYNAMIC_IMAGE_SELECTOR = ".configurator-dynamic-image";
    const PRODUCT_OPTION_IMAGE_SELECTOR = ".product-option-thumb-img";
    var initLoad = true;

    document.addEventListener("productOptionChanged", (event) => {      
        displayLayeredImages(event.detail.selected);
    });

    function hoverInProductOptionThumbnail(event) {
        var element = $(event.target);        
        if (element.attr("class").indexOf("composite-image-thumb") == -1) {
            var image = $(element).first("img");
            var imageUrl = 'url("' + $(image).data('fullSizeImageUrl'); + '")';
            $(CONFIGURATOR_DYNAMIC_IMAGE_SELECTOR).css({ "background-image": imageUrl });
            $("#product-option-title").text($(image).data("productOptionTitle"));
        }
        else {
            $(CONFIGURATOR_DYNAMIC_IMAGE_SELECTOR).css({ "background-image": layeredImagesUrls });
            $("#product-option-title").text("");
        }
    }

    function displayLayeredImages(selectedOptions) {        
        // select images        
        let images = configuratorDynamicImagesData
            .filter((d) => d.Options.every((o) => selectedOptions.some(x => x.ProductCode == o)))
            .sort((a, b) => b.Layer - a.Layer)   // image with higher layer number has to go first
            ;

        // find difference between selectedOptions and images to get not used options so we can display their thumbnails
        var notUsedOptions = selectedOptions.filter(x => !Array.from(new Set(images.map(x => x.Options).flat())).includes(x.ProductCode));
        if (notUsedOptions.length) {
            //$("#product-options-thumbs").empty();
            $("#product-options-thumbs").empty();
            var thumbsHtml = "";
            notUsedOptions.forEach((item) => {
                thumbsHtml += '<div class="product-option-thumbnail"><img class="product-option-thumb-img" src="' + item.Image + '" data-product-option-title="' + item.Title + '" data-full-size-image-url="' + item.FullSizeImage + '" /></div>';
            });
            $("#product-options-thumbs").html(thumbsHtml);
        }
        else
            $("#product-options-thumbs").empty();

        if (images.length) {
            // prepare a list of URLs
            layeredImagesUrls = images
                .map((d) => "url(" + d.Url + ")")
                .join();

            // pre-load the selected images that haven't been loaded yet
            let imagesForPreLoad = images.filter((i) => !i.preLoaded);
            //console.log("images for pre-load: " + imagesForPreLoad.length);
            if (imagesForPreLoad.length) {
                $(".spinner-wrapper").removeClass("d-none");
                layeredImagesToBePreloaded = imagesForPreLoad.length;
                layeredImagesPreLoaded = 0;
                imagesForPreLoad.forEach(function (e) {
                    e.preLoaded = new Image();
                    e.preLoaded.onload = imageLoadedCallback;
                    e.preLoaded.src = e.Url;
                });
            }
            else {
                // nothing to pre-load, we can set the URLs immediately              
                $(COMPOSITE_IMAGE_THUMBNAIL_SELECTOR).css({ "background-image": layeredImagesUrls });
                $(CONFIGURATOR_DYNAMIC_IMAGE_SELECTOR).css({ "background-image": layeredImagesUrls });
            }

            if (!initLoad) {
                var configuratorDynamicImageUrls = $(CONFIGURATOR_DYNAMIC_IMAGE_SELECTOR).css("background-image").split(',');
                // product option is displayed inside configurator dynamic image
                if (configuratorDynamicImageUrls.length == 1) {
                    // check does that product option exists in thumbnails
                    // if it is not exist, show layered images inside configurator dynamic image
                    var productOptionImageUrl = configuratorDynamicImageUrls[0].replace("url(", "").replace(")", "");
                    var productOptionThumb = $(".product-options-thumbs " + PRODUCT_OPTION_IMAGE_SELECTOR).first('src="' + productOptionImageUrl + '"');
                    if (productOptionThumb.length == 0) {
                        $(CONFIGURATOR_DYNAMIC_IMAGE_SELECTOR).css({ "background-image": layeredImagesUrls });
                        $("#product-option-title").text("");
                    }
                }
            }
        }
        else {
            // there are no images so display default configurator image           
            $(COMPOSITE_IMAGE_THUMBNAIL_SELECTOR).css({ "background-image": "url('" + defaultConfiguratorImage + "')" });
            $(CONFIGURATOR_DYNAMIC_IMAGE_SELECTOR).css({ "background-image": "url('" + defaultConfiguratorImage + "')" });
        }

        $(PRODUCT_OPTION_IMAGE_SELECTOR).off("mouseenter").on("mouseenter", hoverInProductOptionThumbnail);

        function imageLoadedCallback() {
            layeredImagesPreLoaded++;          
            if (layeredImagesPreLoaded === layeredImagesToBePreloaded) {
                // all images are loaded, set the background URLs                
                $(COMPOSITE_IMAGE_THUMBNAIL_SELECTOR).css({ "background-image": layeredImagesUrls });               
                $(CONFIGURATOR_DYNAMIC_IMAGE_SELECTOR).css({ "background-image": layeredImagesUrls });
                initLoad = false;                
                $(".spinner-wrapper").addClass("d-none");    // showing and hiding the spinner will have to be done using the Spinner module in real code
            }
        }
    }
        
    // Pre-loading all images on page load so the transitions are seamless.CAREFUL! THIS SPENDS A LOT OF BANDWIDTH!
    //ImagesData.forEach(function (e) {
    //    e.preLoaded = new Image();
    //    e.preLoaded.src = e.Url;
    //});

    // zoom functionality init
    const elem = document.getElementById("zoom-element");
    const panzoom = Panzoom(elem, { minScale: 1, maxScale: 5, cursor: "unset", panOnlyWhenZoomed: true });
    $(".configurator-image-container")
        .on("click", function (event) {
            if (event.currentTarget.classList.contains("zoomed-in")) {
                event.currentTarget.classList.remove("zoomed-in");
                panzoom.reset({ animate: true, duration: 500 });
            }
            else {
                panzoom.zoom(3);
                pan(this, event, { animate: true, duration: 500 });
                event.currentTarget.classList.add("zoomed-in");
            }
        })
        /*.on("wheel", function (event) {     panzoom.zoomWithWheel(event.originalEvent);   })*/
        .on("mouseout", function (event) {
            event.currentTarget.classList.remove("zoomed-in");
            panzoom.reset({ animate: true, duration: 500 });
        })
        .on("mousemove", function (event) { pan(this, event); });

    function pan(element, event, options) {
        /*let logString = "event.pageX = " + event.pageX + "</br>";
        logString += "event.pageY = " + event.pageY + "</br>";
        logString += "$(element).offset().left = " + $(element).offset().left + "</br>";
        logString += "$(element).offset().top = " + $(element).offset().top + "</br>";
        logString += "$(element).width() = " + $(element).width() + "</br>";
        logString += "$(element).height() = " + $(element).height() + "</br>";
        logString += "panzoom.getScale() = " + panzoom.getScale() + "</br>";*/
        let x = -((event.pageX - $(element).offset().left - $(element).width() / 2) * 2) / panzoom.getScale();
        let y = -((event.pageY - $(element).offset().top - $(element).height() / 2) * 2) / panzoom.getScale();
        //logString += "x = " + x + "</br>"; logString += "y = " + y + "</br>";
        panzoom.pan(x, y, options);
    }

    function initConfiguratorDynamicImage() {
        displayLayeredImages([]);
    }

    initConfiguratorDynamicImage();
});

define("ConfiguratorDynamicImage/main", function(){});

